import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SummaryState {
  summaryData: any;
  // ... other state properties
}

const initialState: SummaryState = {
  summaryData: {},
  // ... other initial state
};

const summarySlice = createSlice({
  name: 'summary',
  initialState,
  reducers: {
    setSummaryData: (state, action: PayloadAction<any>) => {
      state.summaryData = action.payload;
    },
    // ... other reducers
  }
});

export const { setSummaryData } = summarySlice.actions;
export default summarySlice.reducer; 